import { FC, ReactNode, useCallback, useMemo, useState } from 'react';
import { ShareContext, ShareContextType, ShareTarget } from './context';
import ShareDialog from './ShareDialog';

// ==============================|| CITYZEN - SHARE PROVIDER (global, entity-agnostic) ||============================== //

export const ShareProvider: FC<{ children: ReactNode }> = ({ children }) => {
	const [target, setTarget] = useState<ShareTarget | null>(null);

	const openShare = useCallback((next: ShareTarget) => setTarget(next), []);
	const closeShare = useCallback(() => setTarget(null), []);

	const value = useMemo<ShareContextType>(
		() => ({ target, openShare, closeShare }),
		[target, openShare, closeShare]
	);

	return (
		<ShareContext.Provider value={value}>
			{children}
			<ShareDialog />
		</ShareContext.Provider>
	);
};
